import dayjs from "@/lib/dayjs";

import type { DateRange } from "@/components/ui/calendar/types/calendar-range";

const FORMAT_DATE = "YYYY-MM-DD";

/**
 * 発行日が期間内の領収書だけを残す
 * 期間を選んでいなければ全件、終了日を選んでいなければ開始日の 1 日だけを対象にする
 */
export const filterByIssuedDate = <T extends { issuedAt: number }>(receipts: T[], { from, to }: DateRange): T[] => {
	if (!from) {
		return receipts;
	}

	const end = to || from;
	return receipts.filter((receipt) => {
		const issuedDate = dayjs(receipt.issuedAt).format(FORMAT_DATE);
		return from <= issuedDate && issuedDate <= end;
	});
};
